var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "title-sec" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 billing-tab" }, [
          _c(
            "a",
            {
              class: _vm.currentPath == "/billing-details" ? "tab-active" : "",
              attrs: { href: "/billing-details" }
            },
            [_vm._v("Membership")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              class: _vm.currentPath == "/billing-impacts" ? "tab-active" : "",
              attrs: { href: "/billing-impacts" }
            },
            [_vm._v("Impact")]
          ),
          _vm._v(" "),
          _vm.company.token_management_access === "1"
            ? _c(
                "a",
                {
                  class:
                    _vm.currentPath == "/billing-tokens" ? "tab-active" : "",
                  attrs: { href: "/billing-tokens" }
                },
                [_vm._v("Tokens")]
              )
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("h1", [_vm._v("Billing")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Manage your payment methods and view your billing details here."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e169841", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e169841","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/business/Billing/tabs.vue
// module id = null
// module chunks = 